import { useEffect } from "react";
import { change } from "redux-form";
import { PersistFiltersProps } from ".";
import useEffectOnce from "hooks/useEffectOnce";
import { userActions } from "redux/slices/user";
import { driverActions } from "redux/slices/driver";
import { bookingActions } from "redux/slices/booking";
import { ratingActions } from "redux/slices/rating";
import { vehicleActions } from "redux/slices/vehicle";
import { invoiceActions } from "redux/slices/invoice";
import { searchHistoryActions } from "redux/slices/searchHistory";
import { contactActions } from "redux/slices/contact";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { reportedProblemActions } from "redux/slices/reportedProblem";
import { classActions } from "redux/slices/class";
import { pricingActions } from "redux/slices/pricing";
import { partnerActions } from "redux/slices/partner";
import { carMovementActions } from "redux/slices/carMovement";
import { smartActions } from "redux/slices/smart";
import { paymentLinkActions } from "redux/slices/paymentLink";
import { allSourceBookingActions } from "redux/slices/allSourceBooking";
import { trafficViolationActions } from "redux/slices/trafficViolation";
import { companyActions } from "redux/slices/company";
import { roleActions } from "redux/slices/role";
import { companyInvoiceActions } from "redux/slices/companyInvoice";


export default function PersistFilters({
  form,
  bookingType = "all",
  invoiceType = "latest",
  type = "open",
  companyInvoice = false,
}: PersistFiltersProps) {
  const dispatch = useAppDispatch();
  const formValues = useAppSelector((state) => state.form?.[form]?.values);
  const user_current_filters = useAppSelector((state) => state.user.current_filters);
  const driver_current_filters = useAppSelector((state) => state.driver.current_filters);
  const vehicle_current_filters = useAppSelector((state) => state.vehicle.current_filters);
  const booking_current_filters = useAppSelector((state) => state.booking[bookingType].current_filters);
  const invoice_current_filters = useAppSelector((state) => state.invoice[invoiceType].current_filters);
  const payroll_current_filters = useAppSelector((state) => state.payroll.current_filters);
  const rating_booking_current_filters = useAppSelector((state) => state.rating.current_filters);
  const searchHistory_current_filters = useAppSelector((state) => state.searchHistory.current_filters);
  const contact_current_filters = useAppSelector((state) => state.contact[type].current_filters);
  const reportedProblem_current_filters = useAppSelector((state) => state.reportedProblem[type].current_filters);
  const class_current_filters = useAppSelector((state) => state.class.current_filters);
  const pricing_current_filters = useAppSelector((state) => state.pricing.current_filters);
  const partner_current_filters = useAppSelector((state) => state.partner.current_filters);
  const carMovement_current_filters = useAppSelector((state) => state.carMovement.current_filters);
  const Smart_current_filters = useAppSelector((state) => state.smart.current_filters);
  const paymentLink_current_filters = useAppSelector((state) => state.paymentLink.current_filters);
  const allsource_current_filters = useAppSelector((state) => state.allsource.current_filters);
  const trafficViolation_current_filters = useAppSelector((state) => state.trafficViolation.current_filters);
  const companies_current_filters = useAppSelector((state) => state.company.current_filters);
  const role_current_filters = useAppSelector((state) => state.role.current_filters);
  const companyInvoice_current_filters = useAppSelector(
    (state) => state.companyInvoice[invoiceType]?.current_filters || {}
  );

  useEffectOnce(() => {
    let obj: any = {};

    if (form === "BookingFiltersForm") obj = booking_current_filters;
    else if (form === "BookingRatingFiltersForm") obj = rating_booking_current_filters;
    else if (form === "InvoiceFiltersForm") obj = invoice_current_filters;
    else if (form === "CompanyInvoiceFiltersForm") obj = companyInvoice_current_filters;
    else if (form === "UserFiltersForm") obj = user_current_filters;
    else if (form === "DriverFiltersForm") obj = driver_current_filters;
    else if (form === "VehicleFiltersForm") obj = vehicle_current_filters;
    else if (form === "PayRollFilters") obj = payroll_current_filters;
    else if (form === "SearchHistoryFiltersForm") obj = searchHistory_current_filters;
    else if (form === "ContactFiltersForm") obj = contact_current_filters;
    else if (form === "ReportedProblemsFiltersForm") obj = reportedProblem_current_filters;
    else if (form === "ClassFiltersForm") obj = class_current_filters;
    else if (form === "PricingFiltersForm") obj = pricing_current_filters;
    else if (form === "PartnerFiltersForm") obj = partner_current_filters;
    else if (form === "CarMovementFiltersForm") obj = carMovement_current_filters;
    else if (form === "SmartBookingFiltersForm") obj = Smart_current_filters;
    else if (form === "PaymentLinkFiltersForm") obj = paymentLink_current_filters;
    else if (form === "AllSourceBookingsFilter") obj = allsource_current_filters;
    else if (form === "TrafficViolationFiltersForm") obj = trafficViolation_current_filters;
    else if (form === "CompaniesFiltersForm") obj = companies_current_filters;
    else if (form === "RoleFiltersForm") obj = role_current_filters;
    

    for (const key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        const element = obj[key];
        dispatch(change(form, key, element));
      }
    }
  });

  useEffect(() => {
    if (!formValues) return;

    if (form === "BookingFiltersForm")
      dispatch(
        bookingActions.setCurrentFilters({
          type: bookingType,
          data: formValues,
        })
      );
    else if (form === "BookingRatingFiltersForm")
      dispatch(ratingActions.setCurrentFilters(formValues));
    else if (form === "InvoiceFiltersForm")
      dispatch(
        invoiceActions.setCurrentFilters({
          type: invoiceType,
          data: formValues,
        })
      );
    else if (form === "CompanyInvoiceFiltersForm" && companyInvoice)
      dispatch(
        companyInvoiceActions.setCurrentFilters({
          type: invoiceType,
          data: formValues,
        })
      );
    else if (form === "UserFiltersForm")
      dispatch(userActions.setCurrentFilters(formValues));
    else if (form === "DriverFiltersForm")
      dispatch(driverActions.setCurrentFilters(formValues));
    else if (form === "VehicleFiltersForm")
      dispatch(vehicleActions.setCurrentFilters(formValues));
    else if (form === "SearchHistoryFiltersForm")
      dispatch(searchHistoryActions.setCurrentFilters(formValues));
    else if (form === "ContactFiltersForm")
      dispatch(contactActions.setCurrentFilters({ type: type, data: formValues, }));
    else if (form === "ReportedProblemsFiltersForm")
      dispatch(reportedProblemActions.setCurrentFilters({ type: type, data: formValues, }));
    else if (form === "ClassFiltersForm")
      dispatch(classActions.setCurrentFilters(formValues));
    else if (form === "PricingFiltersForm")
      dispatch(pricingActions.setCurrentFilters(formValues));
    else if (form === "PartnerFiltersForm")
      dispatch(partnerActions.setCurrentFilters(formValues));
    else if (form === "CarMovementFiltersForm")
      dispatch(carMovementActions.setCurrentFilters(formValues));
    else if (form === "SmartBookingFiltersForm")
      dispatch(smartActions.setCurrentFilters(formValues));
    else if (form === "PaymentLinkFiltersForm")
      dispatch(paymentLinkActions.setCurrentFilters(formValues));
    else if (form === "AllSourceBookingsFilter")
      dispatch(allSourceBookingActions.setCurrentFilters(formValues));
    else if (form === "TrafficViolationFiltersForm")
      dispatch(trafficViolationActions.setCurrentFilters(formValues));
    else if (form === "CompaniesFiltersForm")
      dispatch(companyActions.setCurrentFilters(formValues));
    else if (form === "RoleFiltersForm")
      dispatch(roleActions.setCurrentFilters(formValues));

  }, [dispatch, form, formValues, bookingType, invoiceType]);

  return null;
}
